import React from "react";
import SlidingButton from "./SlidingButton";

const options = [
    { key: "yes", value: "Yes" },
    { key: "no", value: "No" },
];

function CustomerFacing(props) {
    const { onChange, value } = props;
    return (
        <SlidingButton
            handleChange={(_e, v) => onChange("customer_facing_default", v)}
            title="Customer Facing?"
            value={value}
            options={options}
        />
    );
}

export default CustomerFacing;
